import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { axiosConfig } from "../Helpers/AxiosRequest";
import { API_URL } from "../Helpers/api";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios(axiosConfig("GET", `${API_URL}/auth/me`, null, true))
      .then((res) => {
        setUser(res.data.user);
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  return <UserContext.Provider value={{ user, setUser, loading }}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
